import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box, Heading, Text, Link } from 'theme-ui';
import { keyframes } from '@emotion/react';
import { Helmet } from 'react-helmet';

const wave = keyframes`
  from {
    transform: rotate(5deg);
  }
  to {
    transform: rotate(-5deg);
  }
`;
const IndexPage = () => {
    return (
        <main>
            <Helmet>
                <title>Big Bowden LTD</title>
                <meta name="description" content="The hottest club in the North East" />
                <script async src="https://www.googletagmanager.com/gtag/js?id=G-P4FVQJJGHL"></script>
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                      window.dataLayer = window.dataLayer || [];
                      function gtag(){window.dataLayer.push(arguments);}
                      gtag('js', new Date());

                      gtag('config', 'G-P4FVQJJGHL');
                    `,
                    }}
                />
            </Helmet>
            <Box sx={{ position: 'relative', width: '100vw', height: '100vh' }}>
                <StaticImage
                    style={{ position: 'absolute', width: '100%', height: '100%', filter: 'brightness(0.5)' }}
                    placeholder={'dominantColor'}
                    src={'../images/img2.jpg'}
                    alt=""
                />
                <Box
                    sx={{
                        position: 'absolute',
                        height: '100%',
                        width: '100%',
                        zIndex: '10',

                        color: 'white',
                        textAlign: 'center',
                    }}
                >
                    <Box sx={{ width: '100vw' }}>
                        <Heading
                            sx={{
                                fontSize: ['4rem', null, '7rem'],
                                width: '100vw',
                                mt: '50vh',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            Big Bowden
                            <Box as="span" sx={{ display: 'block' }}>
                                Ltd
                            </Box>
                        </Heading>
                        <Box sx={{ fontFamily: 'Rubik Mono One' }}>
                            <Text sx={{ fontSize: ['0.7rem', null, 2] }}>The hottest club in the North East</Text>
                            <Text
                                sx={{
                                    fontSize: ['0.7rem', null, 2],
                                    mt: 2,
                                    display: 'block',
                                    animation: `${wave} 0.75s ease-in-out infinite alternate`,
                                }}
                            >
                                <Link sx={{ color: 'white' }} href="https://www.youtube.com/watch?v=dQw4w9WgXcQ">
                                    Sign up now
                                </Link>
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </main>
    );
};

export default IndexPage;
